function parseEnvironmentVariables(variables, prefix = "") {
  const ttMonitorEntries = Object.entries(variables).filter((entry) =>
    entry[0].includes(prefix)
  );
  const formatedEntries = ttMonitorEntries.map((entry) => {
    if (entry[1] === "true") {
      entry[1] = true;
    } else if (entry[1] === "false") {
      entry[1] = false;
    }
    return [entry[0].slice(prefix.length), entry[1]];
  });
  return Object.fromEntries(formatedEntries);
}
const envVars = parseEnvironmentVariables(import.meta.env, "VITE_");

// eslint-disable-next-line no-undef
const isBrowser = JSON.parse(IS_IN_BROWSER);
// eslint-disable-next-line no-undef
const isDev = JSON.parse(IS_DEV);
// eslint-disable-next-line no-undef
const storyMode = JSON.parse(STORY_MODE);
// eslint-disable-next-line no-undef
const debugMode = JSON.parse(DEBUG_MODE);
// eslint-disable-next-line no-undef
const allowAnonymousInBrowser = JSON.parse(ALLOW_ANONYMOUS_IN_BROWSER);
// eslint-disable-next-line no-undef
const forcedLocale = FORCED_LOCALE;

const environment = Object.freeze({
  appName: envVars["NAME"],
  env: envVars["ENVIRONMENT"],
  isDev,
  isBarkio: envVars["NAME"] === "barkio",
  isBibino: envVars["NAME"] === "bibino",
  supportsBabies: envVars["SUPPORTS_BABIES"] ?? false,
  supportsDogs: envVars["SUPPORTS_DOGS"] ?? false,
  supportsLullabies: envVars["SUPPORTS_LULLABIES"] ?? false,
  supportsCommands: envVars["SUPPORTS_COMMANDS"] ?? false,
  supportsMultibaby: envVars["SUPPORTS_MULTIBABY"] ?? false,
  isMacOs: window.process?.platform === "darwin",
  isWindows: window.process?.platform === "win32",
  isLinux:
    window.process?.platform !== "darwin" &&
    window.process?.platform !== "win32",
  platform: window.process?.platform || "browser",
  debuggers: envVars.DEBUGGERS,
  isBrowser,
  storyMode,
  debugMode,
  allowAnonymousInBrowser,
  // language code, mostly undefined, useful for testing
  forcedLocale,
  publicPath: !import.meta.env.DEV && isBrowser ? "/webapp" : ""
});
export default environment;

console.log(envVars);
console.log(environment);

export function getEnvironmentVariable(variableName) {
  return envVars[variableName];
}

export function getAppValue(data) {
  return data[environment.appName] || data["default"];
}

export function BarkioOnly({ children: Component, ...props }) {
  return environment.isBarkio ? <Component {...props} /> : null;
}

export function BibinoOnly({ children: Component, ...props }) {
  return environment.isBibino ? <Component {...props} /> : null;
}

export function electronOnly(func, { disable } = {}) {
  if (environment.isBrowser && !disable) return undefined;
  return func();
}

export function getModulePublicPathPrefix() {
  const { publicPath } = environment;
  const prefix = publicPath ? publicPath.split("/")[1] + "/" : "";
  return prefix;
}
